import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconClipboard, IconDownload } from '@tabler/icons';
import { memo, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const programmingLanguages = {
    javascript: '.js',
    python: '.py',
    java: '.java',
    c: '.c',
    cpp: '.cpp',
    'c++': '.cpp',
    'c#': '.cs',
    ruby: '.rb',
    php: '.php',
    swift: '.swift',
    'objective-c': '.m',
    kotlin: '.kt',
    typescript: '.ts',
    go: '.go',
    perl: '.pl',
    rust: '.rs',
    scala: '.scala',
    haskell: '.hs',
    lua: '.lua',
    shell: '.sh',
    sql: '.sql',
    html: '.html',
    css: '.css',
};
const CodeBlock = memo(({ language, downloadName, isDialog, value }) => {
    var _a;
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const openPopOver = Boolean(anchorEl);
    const handleClosePopOver = () => {
        setAnchorEl(null);
    };
    const copyToClipboard = (event) => {
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
            return;
        }
        navigator.clipboard.writeText(value).catch(error => {
            console.error('Failed to copy text to clipboard:', error);
        });
        setAnchorEl(event.currentTarget);
        setTimeout(() => {
            handleClosePopOver();
        }, 1500);
    };
    const downloadAsFile = () => {
        const fileExtension = programmingLanguages[language] || '.file';
        const suggestedFileName = `file-${downloadName}${fileExtension}`;
        const fileName = suggestedFileName;
        if (!fileName) {
            // user pressed cancel on prompt
            return;
        }
        const blob = new Blob([value], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = fileName;
        link.href = url;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    return (_jsxs("div", { style: { width: isDialog ? '' : 300 }, children: [_jsx(Box, { sx: { color: 'white', background: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.common.dark, p: 1, borderTopLeftRadius: 10, borderTopRightRadius: 10 }, children: _jsxs("div", { style: { display: 'flex', flexDirection: 'row', alignItems: 'center' }, children: [language, _jsx("div", { style: { flex: 1 } }), _jsx(IconButton, { href: "#", size: "small", title: "Copy", color: "success", onClick: copyToClipboard, children: _jsx(IconClipboard, {}) }), _jsx(Popover, { open: openPopOver, anchorEl: anchorEl, onClose: handleClosePopOver, anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right',
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            }, children: _jsx(Typography, { variant: "h6", sx: { pl: 1, pr: 1, color: 'white', background: theme.palette.success.dark }, children: "Copied!" }) }), _jsx(IconButton, { size: "small", title: "Download", color: "primary", onClick: downloadAsFile, children: _jsx(IconDownload, {}) })] }) }), _jsx(SyntaxHighlighter, { language: language, style: oneDark, customStyle: { margin: 0 }, children: value })] }));
});
CodeBlock.displayName = 'CodeBlock';
export default CodeBlock;
//# sourceMappingURL=CodeBlock.js.map